import './Navigation.css';
import { Link, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { useUI } from '../../hooks/useUI';
import { resources } from '../../utils/resources';

const Navigation = (props) => {

    const { activeNavItem, setNavItemActive } = useUI();
    const location = useLocation();

    useEffect(() => {
        const pathToId = {
            '/': 'home',
            '/rewards': 'rewards',
            '/wallets': 'wallets',
            '/card': 'card',
            '/buyback': 'buyback'
        };
        setNavItemActive(pathToId[location.pathname] || 'home');
    }, [location, setNavItemActive]);

    const handleNavClick = (id) => {
        setNavItemActive(id);
    };

    return (
        <div className='nav-wrapper'>
            <nav className='nav'>

                <div className="nav__wrp">
                    <Link
                        to='/'
                        onClick={() => handleNavClick('home')}
                        className={`nav__item nav__home ${activeNavItem === 'home' ? 'active' : ''}`}
                        style={activeNavItem === 'home' ? { backgroundImage: `url(${resources.icons.home})` } : { backgroundImage: `url(${resources.icons.homeNotActive})` }}
                    >
                        Home
                    </Link>
                    <Link
                        to='/rewards'
                        onClick={() => handleNavClick('rewards')}
                        className={`nav__item nav__rewards ${activeNavItem === 'rewards' ? 'active' : ''}`}
                        style={activeNavItem === 'rewards' ? { backgroundImage: `url(${resources.icons.bag})` } : { backgroundImage: `url(${resources.icons.bagNotActive})` }}
                    >
                        Rewards
                    </Link>
                    <Link
                        to='/wallets'
                        onClick={() => handleNavClick('wallets')}
                        className={`nav__item nav__wallets ${activeNavItem === 'wallets' ? 'active' : ''}`}
                        style={activeNavItem === 'wallets' ? { backgroundImage: `url(${resources.icons.wallet})` } : { backgroundImage: `url(${resources.icons.walletNotActive})` }}
                    >
                        Wallets
                    </Link>
                    <Link
                        to='/card'
                        onClick={() => handleNavClick('card')}
                        className={`nav__item nav__card ${activeNavItem === 'card' ? 'active' : ''}`}
                        style={activeNavItem === 'card' ? { backgroundImage: `url(${resources.icons.card})` } : { backgroundImage: `url(${resources.icons.cardNotActive})` }}
                    >
                        Card
                    </Link>
                    <Link
                        to='/buyback'
                        onClick={() => handleNavClick('buyback')}
                        className={`nav__item nav__card ${activeNavItem === 'buyback' ? 'active' : ''}`}
                        style={activeNavItem === 'buyback' ? { backgroundImage: `url(${resources.icons.buyback})` } : { backgroundImage: `url(${resources.icons.buybackNotActive})` }}
                    >
                        Buy Back
                    </Link>
                </div>
            </nav>
        </div>
    )
}

export default Navigation;